import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=9cab3a4a&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style0 from "./Item.vue?vue&type=style&index=0&id=9cab3a4a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cab3a4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cab3a4a')) {
      api.createRecord('9cab3a4a', component.options)
    } else {
      api.reload('9cab3a4a', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=9cab3a4a&scoped=true", function () {
      api.rerender('9cab3a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LittleActivityCreation/components/Item.vue"
export default component.exports